import script from "./SendCreditDetail.vue?vue&type=script&setup=true&name=SendCreditDetail&lang=js"
export * from "./SendCreditDetail.vue?vue&type=script&setup=true&name=SendCreditDetail&lang=js"

import "./SendCreditDetail.vue?vue&type=style&index=0&id=6ee9a032&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ee9a032"]])

export default __exports__